<script>
import API from "../../../API";
import toaster from "../../common/toaster";

import DialogBody from "../../dialog/components/dialog-body.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import Loading from "../../common/loading.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import DialogBase from "../../dialog/components/dialog-base.vue";
import TextField from "../../common/text-field.vue";
import PropertyTable from "../../common/property-table.vue";

export default {
    name: "usergroup-dialog",
    components: {PropertyTable, TextField, DialogBase, DialogHeader, Loading, DialogActionbar, DialogBody},
    data() {
        const name = Lang.langGet('Name');
        const mustEnter = Lang.langGet('You must enter a ');

        return {
            showDialog: false,
            processing: false,
            invalid: true,
            name: '',
            nameToEdit: '',
            id: undefined,
            parentOptions: [],
            screenOptions: [],
            screengroupOptions: [],
            layerOptions: [],
            selectedParentId: undefined,
            selectedScreenIds: [],
            selectedScreengroupIds: [],
            selectedLayerIds: [],

            stringRules: {
                required: value => !!value || mustEnter + name
            }
        }
    },
    computed: {
        parentItems() {
            return Object.keys(this.parentOptions).map(index => {
                const child = this.parentOptions[index];

                const currentId = child.id;
                const currentName = child.name;
                const selected = this.selectedParentId === currentId;

                return {name: currentName, id: currentId, children: null, selected: selected, level: child.level};
            });

        },
        screengroupItems() {
            return Object.keys(this.screengroupOptions).map(index => {
                const child = this.screengroupOptions[index];

                const currentId = child.id;
                const currentName = child.name;
                const selected = this.selectedScreengroupIds.some(id => id === currentId);

                return {name: _.startCase(currentName), id: currentId, children: null, selected: selected};
            });
        },
        screenItems() {
            return Object.keys(this.screenOptions).map(index => {
                const child = this.screenOptions[index];

                const currentId = child.id;
                const currentName = child.name;
                const selected = this.selectedScreenIds.some(id => id === currentId);

                return {name: currentName, id: currentId, children: null, selected: selected};
            });
        },
        layerItems() {
            return Object.keys(this.layerOptions).map(index => {
                const child = this.layerOptions[index];

                const currentId = child.id;
                const currentName = child.name;
                const selected = this.selectedLayerIds.some(id => id === currentId);

                return {name: _.startCase(currentName), id: currentId, children: null, selected: selected};
            });
        },
        translations() {
            return {
                placeholder: Lang.langGet('New usergroup name'),
                parentGroupName: Lang.langGet('Parent usergroup'),
                noParentGroup: Lang.langGet('None'),
                screenName: Lang.langGet('Screens'),
                screengroupsName: Lang.langGet('Screengroups'),
                layersName: Lang.langGet('Layers'),
                addUsergroup: Lang.langGet('Add new usergroup'),
                editUsergroup: Lang.langGet('Edit usergroup'),
                name: Lang.langGet('Name'),
                addedSuccessfully: Lang.langGet('Usergroup :name added successfully', {name: this.name}),
            }
        },
    },
    watch: {
        name(newName) {
            this.invalid = !newName;
        }
    },
    methods: {
        handleSelectAll(value, list, selected) {
            if (!value) {
                Object.keys(list).map(index => {
                    selected.push(list[index]?.id);
                });
            } else {
                selected.splice(0, selected.length);
            }

            return selected;
        },
        show() { this.showDialog = true; },
        hide() { this.showDialog = false; },
        refreshList() {
            EaseEventBus.fire('reloadUsergroupTable');
        },
        handleClose() { this.hide(); },
        handleChange(newName) {
            this.name = newName;
        },
        toggleListIds(itemId, list) {
            const index = list.findIndex(id => id === itemId);
            if (index < 0) {
                list.push(itemId);
            } else {
                list.splice(index, 1);
            }
        },
        handleParentItemClick(itemId) {
            if (itemId === -1) {
                this.selectedParentId = undefined;
            }
            else {
                this.selectedParentId = itemId ? itemId : undefined;
            }
        },
        handleTableItemClick(item, list) {
            // console.log('change', item, list);
            this.toggleListIds(item.id, list);
        },
        async handleSave() {
            this.processing = true;
            const url = this.id
                ? '/administration/usergroup/edit'
                : '/administration/usergroup/add';
            const api = new API(url);


            const data = {project_id: Laravel.activeProject, name: this.name, parent: this.selectedParentId,
                screens: this.selectedScreenIds, screengroups: this.selectedScreengroupIds, layers: this.selectedLayerIds};

            if (this.id) {
                data.id = this.id;
            }

            // console.log('Saving with', data);
            const result = await api.post(data);
            this.processing = false;

            if (result.errored) {
                this.errored = true;
            } else {
                this.errored = false;
                toaster.success(this.translations.addedSuccessfully);
                this.refreshList();
                this.hide();
            }
        },
        addResultToSelected(result) {
            Object.keys(result).map((item) => {
                const value = result[item];

                if (item === 'screens') {
                    this.selectedScreenIds = value;
                } else if (item === 'screengroups') {
                    this.selectedScreengroupIds = value;
                } else if (item === 'layers') {
                    this.selectedLayerIds = value;
                }
            });
        },
        addResultToTables(result) {
            this.parentOptions = [];
            this.screenOptions = [];
            this.screengroupOptions = [];
            this.layerOptions = [];

            //add a usergroup to the selectable parent usergroups which represents no parent
            this.parentOptions.push({name: this.translations.noParentGroup, id: -1, children: null, selected: this.selectedParentId, level: 0})

            Object.keys(result).map((item) => {
               Object.keys(result[item]).map((index) => {
                   const value = result[item][index];

                   if (item === 'allParents') {
                       const currentName = '-'.repeat(value.level) + _.startCase(value.name);
                       this.parentOptions.push({name: currentName, id: value.id, children: null, selected: this.selectedParentId, level: value.level});
                   } else if (item === 'allScreens') {
                       this.screenOptions.push({name: value.fullname, id: value.id, children: null, selected: this.selectedScreenIds});
                   } else if (item === 'allScreengroups') {
                       this.screengroupOptions.push({name: _.startCase(value.name), id: value.id, children: null, selected: this.selectedScreengroupIds});
                   } else if (item === 'allLayers') {
                       this.layerOptions.push({name: _.startCase(value.name), id: value.id, children: null, selected: this.selectedLayerIds});
                   }
               });
            });
        },
        async load() {
            this.processing = true;
            const url = '/administration/usergroup/edit/data';
            const api = new API(url);

            this.selectedScreenIds = [];
            this.selectedLayerIds = [];
            this.selectedScreengroupIds = [];

            const result = await api.post({id: this.id || ''});
            this.processing = false;

            if (result.errored) {
                this.errored = true;
            } else {
                this.errored = false;
                this.addResultToSelected(result);
                this.addResultToTables(result);
            }

            // console.log('Data loaded:', result);
            // console.log('Items for selection', this.parentOptions);
            // console.log('Items for table 2', this.screenOptions);
            // console.log('Items for table 3', this.screengroupOptions);
            // console.log('Items for table 4', this.layerOptions);
        },
        calculateTitleAndButtonHeight() {
            let heightDialogHeader = document.getElementById('usergroup-dialog-header')?.offsetHeight;
            let heightDialogActionbar = document.getElementById('usergroup-dialog-actionbar')?.offsetHeight;
            return heightDialogHeader + heightDialogActionbar ? heightDialogHeader + heightDialogActionbar : 124;
        }
    },
    mounted: function () {
        EaseEventBus.listen('usergroupAdd', () => {
            this.id = null;
            this.nameToEdit = '';
            this.name = '';
            this.show();
            this.load();
        });

        EaseEventBus.listen('usergroupEdit', params => {
            this.id = params.id;
            this.nameToEdit = params.name || '';
            this.name = params.name || '';
            this.selectedParentId = params.parentId || undefined;
            this.show();
            this.load();
        });
    }
}
</script>

<template>
    <dialog-base
        :maxWidth="1000"
        persistent
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            id="usergroup-dialog-header"
            @close="handleClose"
            :title="this.id ? translations.editUsergroup : translations.addUsergroup"
        />
        <loading :loading="processing"/>
        <dialog-body class="d-flex flex-column overflow-hidden" :style="'max-height: calc(90vh - ' + calculateTitleAndButtonHeight() + 'px);'">
            <div class="d-flex flex-column overflow-hidden">
                <div class="d-flex flex-row w-100 pa-2">
                    <div class="d-flex flex-col w-50">
                        <text-field class="pa-2 pt-4"
                                    :label="translations.name"
                                    :value="name"
                                    :placeholder="translations.placeholder"
                                    :rules="[stringRules.required]"
                                    :error="invalid"
                                    autofocus
                                    @input="handleChange"
                        />
                    </div>
                    <div class="d-flex flex-col w-50">
                        <v-select-custom
                            class="pa-2 pt-4"
                            :value="selectedParentId"
                            :items="parentItems"
                            :label="translations.parentGroupName"
                            itemText="name"
                            itemValue="id"
                            popup-used-in-modal
                            @input="handleParentItemClick"
                        />
                    </div>
                </div>
                <div class="d-flex flex-row w-100 h-100 overflow-hidden">
                    <div class="pa-4 pt-0 w-50 d-flex flex-column overflow-y-auto">
                        <property-table
                            :items="screenItems"
                            :propertyName="translations.screenName"
                            @input="(item) => { handleTableItemClick(item, selectedScreenIds) }"
                            @selectAll="(value) =>  { handleSelectAll(value, screenItems, selectedScreenIds) }"
                        />
                    </div>
                    <div class="pa-4 pt-0 w-50 d-flex flex-column overflow-y-auto">
                        <property-table
                            :items="screengroupItems"
                            :propertyName="translations.screengroupsName"
                            @input="(item) => { handleTableItemClick(item, selectedScreengroupIds) }"
                            @selectAll="(value) =>  { handleSelectAll(value, screengroupItems, selectedScreengroupIds) }"
                        />
                    </div>
                    <div class="pa-4 pt-0 w-50 d-flex flex-column overflow-y-auto">
                        <property-table
                            :items="layerItems"
                            :propertyName="translations.layersName"
                            @input="(item) => { handleTableItemClick(item, selectedLayerIds) }"
                            @selectAll="(value) =>  { handleSelectAll(value, layerItems, selectedLayerIds) }"
                        />
                    </div>
                </div>
            </div>
        </dialog-body>
        <dialog-actionbar
            id="usergroup-dialog-actionbar"
            :disableSave="invalid"
            @close="handleClose"
            @save="handleSave"
        />
    </dialog-base>
</template>

<style scoped>

</style>
